module.exports = __webpack_public_path__ + "static/media/website.a1a805bf.svg";